// import React, { useState } from 'react'
// import HeadingStyle from '../../../../../../../components/heading-style/heading-style';
// import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Button, Checkbox, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, SwipeableDrawer, TextField } from '@mui/material';
// import { LoadingButton } from '@mui/lab';
// import ShippingAddressCard from '../../../../../../../components/address-card/shipping-add-card';
// import { AnyAsyncThunk } from '@reduxjs/toolkit/dist/matchers';
// import dayjs from 'dayjs';
// import { AdapterDayjs, } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker, MobileDatePicker } from '@mui/x-date-pickers';
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
// import FileUploadPopup from '../../../../../../../components/popup/file-upload-popup';
// import CommonPopUp from '../../../../../../../components/popup/common-popup';
// import { createPortal } from 'react-dom';
// import { MenuPropsAutoComplete, MenuPropsAutoCompleteNoCheckBox, MenuPropsSelect } from '../../../../../../../core/utility/style';
// import MaterialSymbol from '../../../../../../../components/icons/material-symbol';
// import { ProductCondition } from './enums';
// import { ExpandMore } from '@mui/icons-material';
// import { useTheme, useMediaQuery } from '@mui/material';

// type Props = {
//     proposalData?: any;
//     setShowInput?: any;
//     showInput?: any;
//     setAddressFormData?: any;
//     addressFormData?: any;
//     location?: any;
//     setLocation?: any;
//     loading?: any;
//     saveAddress?: any;
//     addressList?: any;
//     sendAddress?: any;
//     updateDefaultAddress?: any;
//     sendReciviedProduct?: any;
//     setProductCondition?: (condition: ProductCondition) => void;
//     setTermsAccept?: any;
//     setRecivedProductDate?: any;
//     setProductDeliveryRemark?: any;
//     productDeliveryImageUrl?: (data: string) => void;
//     productDeliveryImagePath?: (data: string) => void;
//     productDeliveryImage?: any;
//     setShowUploadPopup?: any;
//     showUploadPopup?: any;
//     proposalAddressId?: any;
//     formError?:any
// }

// const BarterProductInfo = ({ proposalData, setShowInput, showInput, setAddressFormData, addressFormData, location, setLocation, saveAddress, loading, addressList, sendAddress, updateDefaultAddress, sendReciviedProduct, setProductCondition, setTermsAccept, setRecivedProductDate, setProductDeliveryRemark, productDeliveryImageUrl, productDeliveryImagePath, productDeliveryImage, setShowUploadPopup, showUploadPopup, proposalAddressId, formError }: Props) => {
//     const [handleCreative, setHandleCreative] = useState(false);
//     const path = `influencers/proposals/${proposalData?.proposal_id}/product_acknowledgement`;

//     const [openModal, setOpenModal] = useState(false)
//     const [addAddressPopupOpen, setAddAddressPopupOpen] = useState(false)
//     function getAutoCompleteArrey(value: any) {
//         let splitvalue = value.split(",");
//         const temp = {
//             city: splitvalue[0],
//             state: splitvalue[1],
//             country: splitvalue[2],
//         };
//         setAddressFormData({ ...addressFormData, ...temp });
//     }
//     const dateFormat = "YYYY-MM-DD";
//     const handleCloseCreativeImageModal = () => {
//         setHandleCreative(false)
//         const bodyClass = document.getElementsByTagName('html')[0];
//         if (bodyClass) {
//             bodyClass.classList.remove("bodyInnerModalActive");
//         }
//     }

//     const handleCreativeZoom = () => {
//         setHandleCreative(true)
//         const bodyClass = document.getElementsByTagName('html')[0];
//         if (bodyClass) {
//             bodyClass.classList.add("bodyInnerModalActive");
//         }
//     }
//     const [isVisible, setIsVisible] = useState(true);

//     const handleClosePreviewImage = () => {
//         setIsVisible(false);
//     };
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//     const handleAddressPopupClose = () => {
//         setAddAddressPopupOpen(false);
//     };
//     const handleOpenAddressPopup = (data: any) => {
//         setAddAddressPopupOpen(true);

//     };
//     const cancelAddAddress = () => {
//         setShowInput(false);
//         setAddAddressPopupOpen(false);
//     };
//     return (
//         <div>
//             <div className={`updateBarterProduct-container`}>
//                 <div className="app-step-container">
//                     {/* STEP 1 — ADDRESS */}
//                     <Accordion className="app-accordion light">
//                         <AccordionSummary expandIcon={<ExpandMore />}>
//                             <strong>Address details</strong>
//                         </AccordionSummary>

//                         <AccordionDetails>
//                             <div className="section-content">

//                                 {proposalAddressId === 0 && (
//                                     <button className="app-btn-primary" onClick={() => {
//                                         setShowInput(true);

//                                         if (isMobile) {
//                                             setAddAddressPopupOpen(true);
//                                         }
//                                     }}>
//                                         Add address
//                                     </button>
//                                 )}
//                                 {showInput && (
//                                     <>
//                                         {isMobile ? (
//                                             <SwipeableDrawer
//                                                 anchor="bottom"
//                                                 open={addAddressPopupOpen}
//                                                 onClose={cancelAddAddress}
//                                                 onOpen={handleOpenAddressPopup}
//                                                 className="popup-drawer shipping-drawer mobile-app-drawer"
//                                             >
//                                                 <div className="form-block">

//                                                         <div className='d-flex flex-wrap mb-3'>
//                         <div className='col popup-drawer-header'>
//                             <span className='align-self-center'>Add Address</span>

//                             <IconButton
//                                 edge='end'
//                                 color='inherit'
//                                 onClick={cancelAddAddress}
//                                 aria-label='close'
//                             >
//                                 <MaterialSymbol iconName='close' fontweight='200' />
//                             </IconButton>
//                         </div>
//                     </div>
//                                                         {/* <div className="row mx-0 mx-md-3">
//                                                             <TextField
//                                                                 className="w-100 inputFieldSp"
//                                                                 size="small"
//                                                                 onChange={(e) =>
//                                                                     setAddressFormData({
//                                                                         ...addressFormData,
//                                                                         house_no: e.target.value,
//                                                                     })
//                                                                 }
//                                                                 id="id_house_no"
//                                                                 label="Flat. House no."
//                                                             />
//                                                             <TextField
//                                                                 className="w-100 inputFieldSp"
//                                                                 size="small"
//                                                                 onChange={(e) =>
//                                                                     setAddressFormData({
//                                                                         ...addressFormData,
//                                                                         area: e.target.value,
//                                                                     })
//                                                                 }
//                                                                 id="id_area"
//                                                                 label="Area"
//                                                             />
//                                                             <TextField
//                                                                 className="w-100 inputFieldSp"
//                                                                 size="small"
//                                                                 onChange={(e) =>
//                                                                     setAddressFormData({
//                                                                         ...addressFormData,
//                                                                         landmark: e.target.value,
//                                                                     })
//                                                                 }
//                                                                 id="id_landmark"
//                                                                 label="Landmark"
//                                                             />

//                                                             <Autocomplete
//                                                                 className="inputFieldSp"
//                                                                 size="small"
//                                                                 disablePortal
//                                                                 id="combo-box-demo"
//                                                                 onChange={(e: any, v) => getAutoCompleteArrey(v)}
//                                                                 ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
//                                                                 options={
//                                                                     location
//                                                                         ? location?.map(
//                                                                             (res: {
//                                                                                 id: number;
//                                                                                 city: string;
//                                                                                 state: string;
//                                                                                 country: string;
//                                                                             }) => {
//                                                                                 return `${res.city}, ${res.state}, ${res.country}`;
//                                                                             }
//                                                                         )
//                                                                         : ["No Data"]
//                                                                 }
//                                                                 renderInput={(params) => {
//                                                                     return (
//                                                                         <TextField
//                                                                             name="location_id"
//                                                                             {...params}
//                                                                             label="Location"
//                                                                         />
//                                                                     );
//                                                                 }}
//                                                             />

//                                                             <TextField
//                                                                 className="w-100 inputFieldSp"
//                                                                 size="small"
//                                                                 onChange={(e) =>
//                                                                     setAddressFormData({
//                                                                         ...addressFormData,
//                                                                         pincode: e.target.value,
//                                                                     })
//                                                                 }
//                                                                 id="id_pincode"
//                                                                 label="Pincode"
//                                                             />
//                                                             <FormControl
//                                                                 fullWidth
//                                                                 size="small"
//                                                                 className="inputFieldSp"
//                                                             >
//                                                                 <InputLabel id="demo-multiple-name-label ">
//                                                                     Address type
//                                                                 </InputLabel>
//                                                                 <Select
//                                                                     name="address_type"
//                                                                     size="small"
//                                                                     labelId="demo-multiple-name-label"
//                                                                     id="demo-multiple-name"
//                                                                     value={addressFormData.residency_type}
//                                                                     onChange={(e) =>
//                                                                         setAddressFormData({
//                                                                             ...addressFormData,
//                                                                             residency_type: e.target.value,
//                                                                         })
//                                                                     }
//                                                                     label="Address type"
//                                                                     MenuProps={MenuPropsSelect}
//                                                                 >
//                                                                     <MenuItem value={"Home"}>
//                                                                         Home (7am to 9pm delivery)
//                                                                     </MenuItem>
//                                                                     <MenuItem value={"Office"}>
//                                                                         Office/Commercial (10am to 6pm delivery)
//                                                                     </MenuItem>
//                                                                 </Select>
//                                                             </FormControl>
//                                                             <FormControlLabel
//                                                                 defaultChecked={false}
//                                                                 onChange={(e, v) =>
//                                                                     setAddressFormData({
//                                                                         ...addressFormData,
//                                                                         default_address: `${v}`,
//                                                                     })
//                                                                 }
//                                                                 control={<Checkbox />}
//                                                                 label="Set as Default"
//                                                             />
//                                                             <div className="col save-add-can-buttons">
//                                                                 <LoadingButton
//                                                                     id="id_login_btn"
//                                                                     loading={loading}
//                                                                     loadingPosition="start"
//                                                                     className="btn btn-black"
//                                                                     variant="contained"
//                                                                     onClick={saveAddress}
//                                                                 >
//                                                                     Save
//                                                                 </LoadingButton>
//                                                                 <Button
//                                                                     className="btn"
//                                                                     onClick={() => setShowInput(!showInput)}
//                                                                     variant="outlined"
//                                                                     color="error"
//                                                                 >
//                                                                     Cancel
//                                                                 </Button>
//                                                             </div>
//                                                         </div> */}
//                                                         <div className="add-address px-4">
//     <Grid container rowSpacing={2} spacing={2}>
//         <Grid item xs={12}>
//             <TextField
//                 className="w-100 inputFieldSp"
//                 size="small"
//                 label="Flat, House no., Building, Apartment"
//                 onChange={(e) =>
//                     setAddressFormData({
//                         ...addressFormData,
//                         house_no: e.target.value,
//                     })
//                 }
//                 error={!formError?.house_no?.status}
//                 helperText={formError?.house_no?.message}
//             />
//         </Grid>

//         <Grid item xs={12}>
//             <TextField
//                 className="w-100 inputFieldSp"
//                 size="small"
//                 label="Area"
//                 onChange={(e) =>
//                     setAddressFormData({
//                         ...addressFormData,
//                         area: e.target.value,
//                     })
//                 }
//                 error={!formError?.area?.status}
//     helperText={formError?.area?.message}
//             />
//         </Grid>

//         <Grid item xs={12}>
//             <TextField
//                 className="w-100 inputFieldSp"
//                 size="small"
//                 label="Landmark"
//                 onChange={(e) =>
//                     setAddressFormData({
//                         ...addressFormData,
//                         landmark: e.target.value,
//                     })
//                 }
//             />
//         </Grid>

//         <Grid item xs={12}>
//             <Autocomplete
//                 className="inputFieldSp"
//                 size="small"
//                 disablePortal
//                 onChange={(e: any, v) => getAutoCompleteArrey(v)}
//                 ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
//                 options={
//                     location
//                         ? location.map(
//                             (res: any) =>
//                                 `${res.city}, ${res.state}, ${res.country}`
//                         )
//                         : []
//                 }
//                 renderInput={(params) => (
//                     <TextField
//                         {...params}
//                         label="Location"
//                     />
//                 )}
//             />
//         </Grid>

//         <Grid item xs={12}>
//             <TextField
//                 className="w-100 inputFieldSp"
//                 size="small"
//                 label="Pincode"
//                 onChange={(e) =>
//                     setAddressFormData({
//                         ...addressFormData,
//                         pincode: e.target.value,
//                     })
//                 }
//                 error={!formError?.pincode?.status}
//     helperText={formError?.pincode?.message}
//             />
//         </Grid>

//         {/* <Grid item xs={12}>
//             <FormControl fullWidth size="small">
//                 <InputLabel>Address Type</InputLabel>
//                 <Select
//                     value={addressFormData.residency_type}
//                     label="Address Type"
//                     onChange={(e) =>
//                         setAddressFormData({
//                             ...addressFormData,
//                             residency_type: e.target.value,
//                         })
//                     }
//                 >
//                     <MenuItem value="Home">Home</MenuItem>
//                     <MenuItem value="Office">Office</MenuItem>
//                 </Select>
//             </FormControl>
//         </Grid> */}
//         <Grid item xs={12}>
//     <FormControl>
//         <FormLabel>Select Address Type</FormLabel>

//         <RadioGroup
//             row
//             value={addressFormData.residency_type}
//             onChange={(e:any) =>
//                 setAddressFormData({
//                     ...addressFormData,
//                     residency_type: e.target.value,
//                 })
//             }

//         >
//             <FormControlLabel
//                 value="Home"
//                 control={<Radio />}
//                 label="Home"

//             />

//             <FormControlLabel
//                 value="Office"
//                 control={<Radio />}
//                 label="Office"
//             />
//         </RadioGroup>
//         {!formError?.address_type?.status && (
//             <span className="text-danger fs-12">
//                 {formError?.address_type?.message}
//             </span>
//         )}
//     </FormControl>
// </Grid>

//         <Grid item xs={12}>
//             <FormControlLabel
//                 control={<Checkbox />}
//                 label="Set as Default"
//                 onChange={(e, v) =>
//                     setAddressFormData({
//                         ...addressFormData,
//                         default_address: v,
//                     })
//                 }
//             />
//         </Grid>

//         <Grid
//             item
//             xs={12}
//             className="mobile-app-drawer-footer"
//             display="flex"
//             justifyContent="flex-end"
//         >
//             <Button
//                 variant="outlined"
//                 onClick={cancelAddAddress}
//             >
//                 Cancel
//             </Button>

//             <LoadingButton
//                 loading={loading}
//                 className="ms-2"
//                 variant="contained"
//                 onClick={saveAddress}
//             >
//                 Save
//             </LoadingButton>
//         </Grid>
//     </Grid>
// </div>
//                                                 </div>
//                                             </SwipeableDrawer>
//                                         ) : (
//                                             <div className="form-block">
//                                                 <div className="add-address">
//                                                     <div className="row">
//                                                         <div className="col">
//                                                             <HeadingStyle title="Add Address" />
//                                                         </div>
//                                                     </div>
//                                                     <div className="row mx-0 mx-md-3">
//                                                         <TextField
//                                                             className="w-100 inputFieldSp"
//                                                             size="small"
//                                                             onChange={(e) =>
//                                                                 setAddressFormData({
//                                                                     ...addressFormData,
//                                                                     house_no: e.target.value,
//                                                                 })
//                                                             }
//                                                             id="id_house_no"
//                                                             label="Flat. House no."
//                                                         />
//                                                         <TextField
//                                                             className="w-100 inputFieldSp"
//                                                             size="small"
//                                                             onChange={(e) =>
//                                                                 setAddressFormData({
//                                                                     ...addressFormData,
//                                                                     area: e.target.value,
//                                                                 })
//                                                             }
//                                                             id="id_area"
//                                                             label="Area"
//                                                         />
//                                                         <TextField
//                                                             className="w-100 inputFieldSp"
//                                                             size="small"
//                                                             onChange={(e) =>
//                                                                 setAddressFormData({
//                                                                     ...addressFormData,
//                                                                     landmark: e.target.value,
//                                                                 })
//                                                             }
//                                                             id="id_landmark"
//                                                             label="Landmark"
//                                                         />

//                                                         <Autocomplete
//                                                             className="inputFieldSp"
//                                                             size="small"
//                                                             disablePortal
//                                                             id="combo-box-demo"
//                                                             onChange={(e: any, v) => getAutoCompleteArrey(v)}
//                                                             ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
//                                                             options={
//                                                                 location
//                                                                     ? location?.map(
//                                                                         (res: {
//                                                                             id: number;
//                                                                             city: string;
//                                                                             state: string;
//                                                                             country: string;
//                                                                         }) => {
//                                                                             return `${res.city}, ${res.state}, ${res.country}`;
//                                                                         }
//                                                                     )
//                                                                     : ["No Data"]
//                                                             }
//                                                             renderInput={(params) => {
//                                                                 return (
//                                                                     <TextField
//                                                                         name="location_id"
//                                                                         {...params}
//                                                                         label="Location"
//                                                                     />
//                                                                 );
//                                                             }}
//                                                         />

//                                                         <TextField
//                                                             className="w-100 inputFieldSp"
//                                                             size="small"
//                                                             onChange={(e) =>
//                                                                 setAddressFormData({
//                                                                     ...addressFormData,
//                                                                     pincode: e.target.value,
//                                                                 })
//                                                             }
//                                                             id="id_pincode"
//                                                             label="Pincode"
//                                                         />
//                                                         <FormControl
//                                                             fullWidth
//                                                             size="small"
//                                                             className="inputFieldSp"
//                                                         >
//                                                             <InputLabel id="demo-multiple-name-label ">
//                                                                 Address type
//                                                             </InputLabel>
//                                                             <Select
//                                                                 name="address_type"
//                                                                 size="small"
//                                                                 labelId="demo-multiple-name-label"
//                                                                 id="demo-multiple-name"
//                                                                 value={addressFormData.residency_type}
//                                                                 onChange={(e) =>
//                                                                     setAddressFormData({
//                                                                         ...addressFormData,
//                                                                         residency_type: e.target.value,
//                                                                     })
//                                                                 }
//                                                                 label="Address type"
//                                                                 MenuProps={MenuPropsSelect}
//                                                             >
//                                                                 <MenuItem value={"Home"}>
//                                                                     Home (7am to 9pm delivery)
//                                                                 </MenuItem>
//                                                                 <MenuItem value={"Office"}>
//                                                                     Office/Commercial (10am to 6pm delivery)
//                                                                 </MenuItem>
//                                                             </Select>
//                                                         </FormControl>
//                                                         <FormControlLabel
//                                                             defaultChecked={false}
//                                                             onChange={(e, v) =>
//                                                                 setAddressFormData({
//                                                                     ...addressFormData,
//                                                                     default_address: `${v}`,
//                                                                 })
//                                                             }
//                                                             control={<Checkbox />}
//                                                             label="Set as Default"
//                                                         />
//                                                         <div className="col save-add-can-buttons">
//                                                             <LoadingButton
//                                                                 id="id_login_btn"
//                                                                 loading={loading}
//                                                                 loadingPosition="start"
//                                                                 className="btn btn-black"
//                                                                 variant="contained"
//                                                                 onClick={saveAddress}
//                                                             >
//                                                                 Save
//                                                             </LoadingButton>
//                                                             <Button
//                                                                 className="btn"
//                                                                 onClick={() => setShowInput(!showInput)}
//                                                                 variant="outlined"
//                                                                 color="error"
//                                                             >
//                                                                 Cancel
//                                                             </Button>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </>
//                                 )}
//                                 {/* {showInput && (
//                             <div className="form-block">
//                                 <div className="add-address">
//                                     <div className="row">
//                                         <div className="col">
//                                             <HeadingStyle title="Add Address" />
//                                         </div>
//                                     </div>
//                                     <div className="row mx-0 mx-md-3">
//                                         <TextField
//                                             className="w-100 inputFieldSp"
//                                             size="small"
//                                             onChange={(e) =>
//                                                 setAddressFormData({
//                                                     ...addressFormData,
//                                                     house_no: e.target.value,
//                                                 })
//                                             }
//                                             id="id_house_no"
//                                             label="Flat. House no."
//                                         />
//                                         <TextField
//                                             className="w-100 inputFieldSp"
//                                             size="small"
//                                             onChange={(e) =>
//                                                 setAddressFormData({
//                                                     ...addressFormData,
//                                                     area: e.target.value,
//                                                 })
//                                             }
//                                             id="id_area"
//                                             label="Area"
//                                         />
//                                         <TextField
//                                             className="w-100 inputFieldSp"
//                                             size="small"
//                                             onChange={(e) =>
//                                                 setAddressFormData({
//                                                     ...addressFormData,
//                                                     landmark: e.target.value,
//                                                 })
//                                             }
//                                             id="id_landmark"
//                                             label="Landmark"
//                                         />

//                                         <Autocomplete
//                                             className="inputFieldSp"
//                                             size="small"
//                                             disablePortal
//                                             id="combo-box-demo"
//                                             onChange={(e: any, v) => getAutoCompleteArrey(v)}
//                                             ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
//                                             options={
//                                                 location
//                                                     ? location?.map(
//                                                         (res: {
//                                                             id: number;
//                                                             city: string;
//                                                             state: string;
//                                                             country: string;
//                                                         }) => {
//                                                             return `${res.city}, ${res.state}, ${res.country}`;
//                                                         }
//                                                     )
//                                                     : ["No Data"]
//                                             }
//                                             renderInput={(params) => {
//                                                 return (
//                                                     <TextField
//                                                         name="location_id"
//                                                         {...params}
//                                                         label="Location"
//                                                     />
//                                                 );
//                                             }}
//                                         />

//                                         <TextField
//                                             className="w-100 inputFieldSp"
//                                             size="small"
//                                             onChange={(e) =>
//                                                 setAddressFormData({
//                                                     ...addressFormData,
//                                                     pincode: e.target.value,
//                                                 })
//                                             }
//                                             id="id_pincode"
//                                             label="Pincode"
//                                         />
//                                         <FormControl
//                                             fullWidth
//                                             size="small"
//                                             className="inputFieldSp"
//                                         >
//                                             <InputLabel id="demo-multiple-name-label ">
//                                                 Address type
//                                             </InputLabel>
//                                             <Select
//                                                 name="address_type"
//                                                 size="small"
//                                                 labelId="demo-multiple-name-label"
//                                                 id="demo-multiple-name"
//                                                 value={addressFormData.residency_type}
//                                                 onChange={(e) =>
//                                                     setAddressFormData({
//                                                         ...addressFormData,
//                                                         residency_type: e.target.value,
//                                                     })
//                                                 }
//                                                 label="Address type"
//                                                 MenuProps={MenuPropsSelect}
//                                             >
//                                                 <MenuItem value={"Home"}>
//                                                     Home (7am to 9pm delivery)
//                                                 </MenuItem>
//                                                 <MenuItem value={"Office"}>
//                                                     Office/Commercial (10am to 6pm delivery)
//                                                 </MenuItem>
//                                             </Select>
//                                         </FormControl>
//                                         <FormControlLabel
//                                             defaultChecked={false}
//                                             onChange={(e, v) =>
//                                                 setAddressFormData({
//                                                     ...addressFormData,
//                                                     default_address: `${v}`,
//                                                 })
//                                             }
//                                             control={<Checkbox />}
//                                             label="Set as Default"
//                                         />
//                                         <div className="col save-add-can-buttons">
//                                             <LoadingButton
//                                                 id="id_login_btn"
//                                                 loading={loading}
//                                                 loadingPosition="start"
//                                                 className="btn btn-black"
//                                                 variant="contained"
//                                                 onClick={saveAddress}
//                                             >
//                                                 Save
//                                             </LoadingButton>
//                                             <Button
//                                                 className="btn"
//                                                 onClick={() => setShowInput(!showInput)}
//                                                 variant="outlined"
//                                                 color="error"
//                                             >
//                                                 Cancel
//                                             </Button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             )} */}

//                                 {!showInput && proposalAddressId === 0 ? (
//                                     <ShippingAddressCard
//                                         addressList={addressList}
//                                         setDefaultAddress={sendAddress}
//                                         enableEdit={false}
//                                         onChange={updateDefaultAddress}
//                                     />
//                                 ) : (
//                                     <div>
//                                         {addressList?.map((data: any) =>
//                                             data.address_id === proposalAddressId && (
//                                                 <div key={data.address_id}>
//                                                     {data.house_no && <div>{data.house_no}</div>}
//                                                     {data.landmark && <div>{data.landmark}</div>}
//                                                     {data.city && <div>{data.city} - {data.pincode}</div>}
//                                                     {data.state && <div>{data.state}</div>}
//                                                     {data.country && <div>{data.country}</div>}
//                                                 </div>
//                                             )
//                                         )}
//                                     </div>
//                                 )}

//                             </div>
//                         </AccordionDetails>
//                     </Accordion>

//                     {/* STEP 2 — SHIPPING */}
//                     <Accordion className="app-accordion light" disabled={proposalAddressId === 0}>
//                         <AccordionSummary expandIcon={<ExpandMore />}>
//                             <strong>Product Shipping Details</strong>
//                         </AccordionSummary>

//                         <AccordionDetails>
//                             <div className="section-content product-shipping-detail">
//                                 <p>The brand shares the product shipping details for your
//                                     reference.</p>
//                                 {proposalData?.[0]?.shipping_details && (
//                                     <>
//                                         <div className='d-none d-md-flex flex-column'>
//                                             <strong>Tracking Details</strong>
//                                             <p>{proposalData[0].shipping_details}</p>
//                                         </div>
//                                         <div className='position-relative'>
//                                             <img
//                                                 className="preview-img"
//                                                 src={proposalData[0].shipping_receipt_url}
//                                             />
//                                             <button className="app-btn-outline" onClick={handleCreativeZoom}>
//                                                 <MaterialSymbol iconName='download' fontweight='200' fontSize='30px' />
//                                             </button>
//                                         </div>
//                                         <div className='d-flex d-md-none mt-3'>
//                                             <strong>Tracking Details: &nbsp;</strong>
//                                             <p>{proposalData[0].shipping_details}</p>
//                                         </div>
//                                     </>
//                                 )}

//                             </div>
//                         </AccordionDetails>
//                     </Accordion>

//                     {/* STEP 3 — DELIVERY */}
//                     <Accordion
//                         className="app-accordion light"
//                         disabled={proposalData?.[0]?.shipping_receipt_url?.length === 0}
//                     >
//                         <AccordionSummary expandIcon={<ExpandMore />}>
//                             <strong>Product Delivery Acknowledgement</strong>
//                         </AccordionSummary>

//                         <AccordionDetails>
//                             <div className="section-content">

//                                 {proposalData?.[0]?.product_delivery_status === "Pending" ? (
//                                     <>
//                                         <label>
//                                             <Checkbox onChange={(e, v) => setTermsAccept(v)} />
//                                             Yes, I have received the product.
//                                         </label>

//                                         <FormControl fullWidth size="small">
//                                             <InputLabel>Product Condition</InputLabel>
//                                             <Select
//                                                 defaultValue=""
//                                                 onChange={(e) =>
//                                                     setProductCondition?.(e.target.value as ProductCondition)
//                                                 }
//                                             >
//                                                 <MenuItem value="Good">Good</MenuItem>
//                                                 <MenuItem value="Broken">Broken</MenuItem>
//                                                 <MenuItem value="Expired">Expired</MenuItem>
//                                             </Select>
//                                         </FormControl>

//                                         <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                             <DatePicker
//                                                 minDate={dayjs()}
//                                                 onChange={(e: any) =>
//                                                     setRecivedProductDate(e?.format("YYYY-MM-DD"))
//                                                 }
//                                                 slotProps={{ textField: { size: "small" } }}
//                                             />
//                                         </LocalizationProvider>

//                                         <TextField
//                                             placeholder="Comments"
//                                             fullWidth
//                                             onChange={(e) => setProductDeliveryRemark(e.target.value)}
//                                         />

//                                         {productDeliveryImage ? (
//                                             <img className="preview-img" src={productDeliveryImage} />
//                                         ) : (
//                                             <button
//                                                 className="app-btn-outline"
//                                                 onClick={() => setShowUploadPopup(true)}
//                                             >
//                                                 Upload Product Image
//                                             </button>
//                                         )}

//                                         <LoadingButton
//                                             className="app-btn-primary"
//                                             loading={loading}
//                                             onClick={sendReciviedProduct}
//                                         >
//                                             Send
//                                         </LoadingButton>
//                                     </>
//                                 ) : (
//                                     <>
//                                         <p><strong>Product Condition:</strong> {proposalData?.[0]?.product_condition}</p>

//                                         {proposalData?.[0]?.product_delivery_remarks && (
//                                             <p><strong>Comments:</strong> {proposalData[0].product_delivery_remarks}</p>
//                                         )}

//                                         <img
//                                             className="preview-img"
//                                             src={proposalData[0].product_delivery_image_url}
//                                         />
//                                     </>
//                                 )}

//                             </div>
//                         </AccordionDetails>
//                     </Accordion>
//                 </div>
//                 <div className='d-none d-md-flex flex-md-column'>
//                     <div className="product-detail-container">

//                         <div className="product-detail-title-sec flex-row">
//                             <div className="col">
//                                 <h5>
//                                     <strong>Step 1 (Influencer) :</strong> Address Details{" "}
//                                 </h5>
//                                 <h6>The product delivery address.</h6>
//                             </div>
//                             <div className="col text-end">
//                                 {proposalAddressId === 0 && (
//                                     <button type="button"
//                                         className="btn btn-primary"
//                                         onClick={() => setShowInput(!showInput)}
//                                     >
//                                         Add address
//                                     </button>
//                                 )}
//                             </div>
//                         </div>

//                         <div>
//                             {showInput && (
//                                 <div className="add-address">
//                                     <div className="row">
//                                         <div className="col">
//                                             <HeadingStyle title="Add Address" />
//                                         </div>
//                                     </div>
//                                     <div className="row">
//                                         <div className="row">
//                                             <TextField
//                                                 className="w-100 inputFieldSp"
//                                                 size="small"
//                                                 onChange={(e) =>
//                                                     setAddressFormData({
//                                                         ...addressFormData,
//                                                         house_no: e.target.value,
//                                                     })
//                                                 }
//                                                 id="id_house_no"
//                                                 label="Flat. House no."
//                                             />
//                                             <TextField
//                                                 className="w-100 inputFieldSp"
//                                                 size="small"
//                                                 onChange={(e) =>
//                                                     setAddressFormData({
//                                                         ...addressFormData,
//                                                         area: e.target.value,
//                                                     })
//                                                 }
//                                                 id="id_area"
//                                                 label="Area"
//                                             />
//                                             <TextField
//                                                 className="w-100 inputFieldSp"
//                                                 size="small"
//                                                 onChange={(e) =>
//                                                     setAddressFormData({
//                                                         ...addressFormData,
//                                                         landmark: e.target.value,
//                                                     })
//                                                 }
//                                                 id="id_landmark"
//                                                 label="Landmark"
//                                             />

//                                             <Autocomplete
//                                                 className="inputFieldSp"
//                                                 size="small"
//                                                 disablePortal
//                                                 id="combo-box-demo"
//                                                 onChange={(e: any, v) => getAutoCompleteArrey(v)}
//                                                 ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
//                                                 options={
//                                                     location
//                                                         ? location?.map(
//                                                             (res: {
//                                                                 id: number;
//                                                                 city: string;
//                                                                 state: string;
//                                                                 country: string;
//                                                             }) => {
//                                                                 return `${res.city}, ${res.state}, ${res.country}`;
//                                                             }
//                                                         )
//                                                         : ["No Data"]
//                                                 }
//                                                 renderInput={(params) => {
//                                                     return (
//                                                         <TextField
//                                                             name="location_id"
//                                                             {...params}
//                                                             label="Location"
//                                                         />
//                                                     );
//                                                 }}
//                                             />

//                                             <TextField
//                                                 className="w-100 inputFieldSp"
//                                                 size="small"
//                                                 onChange={(e) =>
//                                                     setAddressFormData({
//                                                         ...addressFormData,
//                                                         pincode: e.target.value,
//                                                     })
//                                                 }
//                                                 id="id_pincode"
//                                                 label="Pincode"
//                                             />
//                                             <FormControl
//                                                 fullWidth
//                                                 size="small"
//                                                 className="inputFieldSp"
//                                             >
//                                                 <InputLabel id="demo-multiple-name-label ">
//                                                     Address type
//                                                 </InputLabel>
//                                                 <Select
//                                                     name="address_type"
//                                                     size="small"
//                                                     labelId="demo-multiple-name-label"
//                                                     id="demo-multiple-name"
//                                                     value={addressFormData.residency_type}
//                                                     onChange={(e) =>
//                                                         setAddressFormData({
//                                                             ...addressFormData,
//                                                             residency_type: e.target.value,
//                                                         })
//                                                     }
//                                                     label="Address type"
//                                                     MenuProps={MenuPropsSelect}
//                                                 >
//                                                     <MenuItem value={"Home"}>
//                                                         Home (7am to 9pm delivery)
//                                                     </MenuItem>
//                                                     <MenuItem value={"Office"}>
//                                                         Office/Commercial (10am to 6pm delivery)
//                                                     </MenuItem>
//                                                 </Select>
//                                             </FormControl>
//                                             <FormControlLabel
//                                                 defaultChecked={false}
//                                                 onChange={(e, v) =>
//                                                     setAddressFormData({
//                                                         ...addressFormData,
//                                                         default_address: `${v}`,
//                                                     })
//                                                 }
//                                                 control={<Checkbox />}
//                                                 label="Set as Default"
//                                             />
//                                             <div className="col save-add-can-buttons">
//                                                 <LoadingButton
//                                                     id="id_login_btn"
//                                                     loading={loading}
//                                                     loadingPosition="start"
//                                                     className="btn btn-black"
//                                                     variant="contained"
//                                                     onClick={saveAddress}
//                                                 >
//                                                     Save
//                                                 </LoadingButton>
//                                                 <Button
//                                                     className="btn"
//                                                     onClick={() => setShowInput(!showInput)}
//                                                     variant="outlined"
//                                                     color="error"
//                                                 >
//                                                     Cancel
//                                                 </Button>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             )}

//                             {!showInput && proposalAddressId === 0 ? (
//                                 <div className="add-address">
//                                     <ShippingAddressCard
//                                         addressList={addressList}
//                                         setDefaultAddress={sendAddress}
//                                         enableEdit={false}
//                                         onChange={updateDefaultAddress}
//                                     />
//                                 </div>
//                             ) : (
//                                 <div className='address-list'>
//                                     {addressList &&
//                                         addressList.map((data: any, index: number) => {
//                                             if (data.address_id === proposalAddressId) {
//                                                 return (
//                                                     <React.Fragment key={index}>
//                                                         {data.house_no && <span className='fs-14 d-block'>{data.house_no}</span>}
//                                                         {data.landmark && <span className='fs-14 d-block'>{data.landmark}</span>}
//                                                         {data.city &&
//                                                             <span className="fs-14 d-block">
//                                                                 {data.city} {data.pincode && ` - ${data.pincode}`}
//                                                             </span>
//                                                         }
//                                                         {data.state && <span className='fs-14 d-block'>{data.state}</span>}
//                                                         {data.country && <span className='fs-14 d-block'>{data.country}</span>}

//                                                     </React.Fragment>
//                                                 );
//                                             }
//                                             return null;
//                                         })}
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     {
//                         <div
//                             className={`product-detail-container ${proposalAddressId > 0
//                                 ? " activefield"
//                                 : " deactivefield"
//                                 }`}
//                         >
//                             <div className="product-detail-title-sec">
//                                 <h5>
//                                     <strong>Step 2 (Brand) : </strong> Product Shipping
//                                     Details{" "}
//                                 </h5>
//                                 <h6>
//                                     The brand shares the product shipping details for your
//                                     reference.
//                                 </h6>
//                             </div>

//                             <div>
//                                 <div className="shipping_receipt_section">
//                                     {proposalData && (
//                                         <>
//                                             {proposalData[0].shipping_details &&
//                                                 <strong className='d-block fs-14'>Tracking Details:</strong>
//                                             }
//                                             <span className='d-block mb-1 fs-14'> {proposalData[0].shipping_details}</span>

//                                             {proposalData[0]?.shipping_details &&
//                                                 <><img
//                                                     className="shipping_receipt_url mb-3"
//                                                     src={proposalData[0].shipping_receipt_url}
//                                                     alt="document"

//                                                 />
//                                                     <button className='btn btn-outline-primary align-items-start mb-2'
//                                                         style={{ cursor: 'pointer' }}
//                                                         // download={proposalData[0].file_name}
//                                                         onClick={handleCreativeZoom}
//                                                     >
//                                                         Download
//                                                     </button>
//                                                 </>
//                                             }
//                                         </>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     }
//                     {
//                         <div
//                             className={`product-detail-container ${proposalData[0].shipping_receipt_url.length === 0
//                                 ? " deactivefield"
//                                 : " activefield"
//                                 }`}
//                         >
//                             <div className="product-detail-title-sec">
//                                 <h5>
//                                     <strong>Step 3 (Influencer) :</strong> Product Delivery
//                                     Acknowledgement{" "}
//                                 </h5>
//                                 <h6>
//                                     Acknowledgement by the influencer and creative timeline
//                                     for your reference.
//                                 </h6>
//                             </div>
//                             <div className="w-100">
//                                 {proposalData &&
//                                     proposalData[0].product_delivery_status === "Pending" ? (
//                                     <div className="shipping_receipt_section">
//                                         <span>
//                                             <Checkbox
//                                                 className="p-0"
//                                                 onChange={(e, v) => setTermsAccept(v)}
//                                                 defaultChecked={false}
//                                             />{" "}
//                                             Yes, I have received the product.
//                                         </span>
//                                         <span className="mt-3">
//                                             <FormControl style={{ minWidth: '250px' }} size="small" >
//                                                 <InputLabel id="demo-simple-select-label">
//                                                     Product Condition:
//                                                 </InputLabel>
//                                                 <Select
//                                                     labelId="demo-simple-select-label"
//                                                     id="demo-simple-select"
//                                                     // value={age}
//                                                     defaultValue={""}
//                                                     label="Product Delivery Status"
//                                                     onChange={(e) => {
//                                                         const newValue = e.target.value as ProductCondition;

//                                                         if (Object.values(ProductCondition).includes(newValue) && setProductCondition) {
//                                                             setProductCondition(newValue);
//                                                         } else if (setProductCondition) {
//                                                             setProductCondition(ProductCondition.Good);
//                                                         }
//                                                     }
//                                                     }
//                                                     MenuProps={MenuPropsSelect}
//                                                 >
//                                                     <MenuItem value={`Good`}>Good</MenuItem>
//                                                     <MenuItem value={`Broken`}>Broken</MenuItem>
//                                                     {/* <MenuItem value={`Rejected`}>Rejected</MenuItem> */}
//                                                     <MenuItem value={`Expired`}>Expired</MenuItem>
//                                                     {/* <MenuItem value={`Other`}>Other</MenuItem> */}
//                                                 </Select>
//                                             </FormControl>
//                                             <span className='d-flex align-items-center '><span className='fs-14'>Creative will be shared by </span><LocalizationProvider dateAdapter={AdapterDayjs}>
//                                                 <DemoContainer
//                                                     components={["shipping_receipt_section"]}
//                                                 >
//                                                     <DatePicker
//                                                         className="ms-2"
//                                                         label=""
//                                                         format="DD-MM-YYYY"
//                                                         // minDate={"12-12-2020"}
//                                                         minDate={dayjs(new Date())}
//                                                         // defaultValue={"12-12-2020"}
//                                                         onChange={(e: any) =>
//                                                             setRecivedProductDate(e?.format(dateFormat))
//                                                         }
//                                                         slotProps={{
//                                                             textField: {
//                                                                 size: "small",
//                                                                 // helperText: "MM/DD/YYYY",
//                                                             },
//                                                         }}
//                                                     />
//                                                 </DemoContainer>
//                                             </LocalizationProvider> </span>

//                                             <TextField
//                                                 id="outlined-basic"
//                                                 label=""
//                                                 size="small"
//                                                 variant="outlined"
//                                                 rows={4}
//                                                 onChange={(e) =>
//                                                     setProductDeliveryRemark(e.target.value)
//                                                 }
//                                                 className="mt-2 w-100"
//                                                 placeholder="Comments"
//                                             />
//                                             <span className="product-image-section">
//                                                 {(isVisible && productDeliveryImage) &&
//                                                     <span className='d-inline-flex position-relative mt-3'>
//                                                         <img
//                                                             className="image-style "
//                                                             src={productDeliveryImage}
//                                                             alt="product"
//                                                         />
//                                                         <button
//                                                             onClick={handleClosePreviewImage}
//                                                             style={{
//                                                                 position: 'absolute',
//                                                                 top: '-8px',
//                                                                 right: '-5px',
//                                                                 background: '#000',
//                                                                 color: 'white',
//                                                                 border: 'none',
//                                                                 borderRadius: '50%',
//                                                                 width: '24px',
//                                                                 height: '24px',
//                                                                 cursor: 'pointer',
//                                                             }}
//                                                         >
//                                                             <MaterialSymbol fontSize='14px' className='d-flex align-items-center' iconName='close' fontweight='200' />
//                                                         </button>
//                                                     </span>
//                                                 }
//                                                 {(!isVisible || !productDeliveryImage) && (
//                                                     <LoadingButton
//                                                         loading={loading}
//                                                         loadingPosition="start"
//                                                         className="btn btn-outline-primary mt-3"
//                                                         variant="contained"
//                                                         onClick={() =>
//                                                             setShowUploadPopup(showUploadPopup)
//                                                         }
//                                                     >
//                                                         Upload Product Image
//                                                     </LoadingButton>
//                                                 )}
//                                             </span>
//                                             {showUploadPopup && (
//                                                 <FileUploadPopup
//                                                     openModal={showUploadPopup}
//                                                     onClose={() => setShowUploadPopup(showUploadPopup)}
//                                                     onSend={(e: { url: string; key: string }) => {
//                                                         productDeliveryImageUrl && productDeliveryImageUrl(e.url);
//                                                         productDeliveryImagePath && productDeliveryImagePath(e.key);
//                                                         setIsVisible(true)
//                                                     }}
//                                                     path={path}
//                                                     acceptedFileTypes=".jpg, .jpeg, .png"
//                                                 />
//                                             )}
//                                         </span>
//                                         <span className="mt-3 mb-3">
//                                             <LoadingButton
//                                                 style={{
//                                                     marginRight: `15px`,
//                                                 }}
//                                                 className="btn btn-primary"
//                                                 loading={loading}
//                                                 loadingPosition="start"
//                                                 variant="contained"
//                                                 onClick={sendReciviedProduct}
//                                             >
//                                                 Send
//                                             </LoadingButton>
//                                         </span>
//                                     </div>
//                                 ) : (
//                                     <div className="shipping_receipt_section">
//                                         <ul className='ps-0'>
//                                             <li>
//                                                 {" "}
//                                                 <strong>Product Condition:</strong>{" "}
//                                                 {
//                                                     proposalData?.[0]?.product_condition ?? "No Status"
//                                                 }
//                                             </li>
//                                             {/* <li>
//                                                 {" "}
//                                                 <strong>Delivery Date: </strong>
//                                                 {dayjs(
//                                                     proposalData[0].product_delivery_date
//                                                 ).format("LL")}
//                                             </li> */}
//                                             {proposalData[0].product_delivery_remarks &&
//                                                 <li>
//                                                     <strong>Comments: </strong>
//                                                     {proposalData[0].product_delivery_remarks}
//                                                 </li>
//                                             }
//                                             <li>
//                                                 <span>
//                                                     <strong>Product Image</strong>
//                                                 </span>
//                                                 <img
//                                                     className="image-style"
//                                                     src={proposalData[0].product_delivery_image_url}
//                                                     alt="product delivery"
//                                                 />
//                                             </li>
//                                         </ul>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     }
//                 </div>
//             </div>



//             {createPortal(<CommonPopUp
//                 key={proposalData[0].proposal_id}
//                 className="creative-img-popup barter-shipping-detail"
//                 modalContent=""
//                 openModal={handleCreative}
//                 modalId={`creative-img-${proposalData[0].proposal_id}`}
//                 onClose={() => handleCloseCreativeImageModal()}
//             >
//                 <div className="container-fluid">
//                     <div className='row creative-detail inner'>
//                         <div className='col-md-12'>

//                             <div className="creative-detail-img">
//                                 <img
//                                     src={proposalData[0].shipping_receipt_url}
//                                     className="selected-creative"
//                                     alt="shipping receipt"
//                                 />
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </CommonPopUp>
//                 , document.body)}



//         </div>
//     )
// }

// export default BarterProductInfo

import React, { useState, useEffect } from 'react'
import HeadingStyle from '../../../../../../../components/heading-style/heading-style';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Button, Checkbox, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, SwipeableDrawer, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import ShippingAddressCard from '../../../../../../../components/address-card/shipping-add-card';
import { AnyAsyncThunk } from '@reduxjs/toolkit/dist/matchers';
import dayjs from 'dayjs';
import { AdapterDayjs, } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker, MobileDatePicker } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import FileUploadPopup from '../../../../../../../components/popup/file-upload-popup';
import CommonPopUp from '../../../../../../../components/popup/common-popup';
import { createPortal } from 'react-dom';
import { MenuPropsAutoComplete, MenuPropsAutoCompleteNoCheckBox, MenuPropsSelect } from '../../../../../../../core/utility/style';
import MaterialSymbol from '../../../../../../../components/icons/material-symbol';
import { ProductCondition } from './enums';
import { ExpandMore } from '@mui/icons-material';
import { PublicService } from '../../../../../../../core/services';
import { useTheme, useMediaQuery } from '@mui/material';

type Props = {
    proposalData?: any;
    setShowInput?: any;
    showInput?: any;
    setAddressFormData?: any;
    addressFormData?: any;
    location?: any;
    setLocation?: any;
    loading?: any;
    saveAddress?: any;
    addressList?: any;
    sendAddress?: any;
    updateDefaultAddress?: any;
    sendReciviedProduct?: any;
    setProductCondition?: (condition: ProductCondition) => void;
    setTermsAccept?: any;
    setRecivedProductDate?: any;
    setProductDeliveryRemark?: any;
    productDeliveryImageUrl?: (data: string) => void;
    productDeliveryImagePath?: (data: string) => void;
    productDeliveryImage?: any;
    setShowUploadPopup?: any;
    showUploadPopup?: any;
    proposalAddressId?: any;
    addressErrors?: any;
    termsAccept?: any
    setAddressErrors?: React.Dispatch<React.SetStateAction<any>>;
    deliveryErrors?: any
}

const BarterProductInfo = ({ proposalData, setShowInput, showInput, setAddressFormData, addressFormData, location, setLocation, saveAddress, loading, addressList, sendAddress, updateDefaultAddress, sendReciviedProduct, setProductCondition, setTermsAccept, termsAccept, setRecivedProductDate, setProductDeliveryRemark, productDeliveryImageUrl, productDeliveryImagePath, productDeliveryImage, setShowUploadPopup, showUploadPopup, proposalAddressId, addressErrors, setAddressErrors, deliveryErrors }: Props) => {
    const publicService = new PublicService();
    const [handleCreative, setHandleCreative] = useState(false);
    const path = `influencers/proposals/${proposalData?.proposal_id}/product_acknowledgement`;
    const [countries, setCountries] = useState<any[]>([]);
    const [states, setStates] = useState<any[]>([]);
    const [cities, setCities] = useState<any[]>([]);

    // const [selectedCountry, setSelectedCountry] = useState<string>('');
    // const [selectedState, setSelectedState] = useState<string>('');
    // const [selectedCity, setSelectedCity] = useState<string>('');
    const [addAddressPopupOpen, setAddAddressPopupOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openDatePicker, setOpenDatePicker] = useState(false);
    const [selectedDate, setSelectedDate] = useState<any>(null);

    useEffect(() => {
        // props.loading(true);
        try {
            // influencerShippingAddressList();
            // load countries list
            const getCountries = async () => {
                try {
                    const res = await publicService.getCountry({});
                    if (res?.status === 1) setCountries(res.data || []);
                    else setCountries([]);
                } catch (error) {
                    setCountries([]);
                }
            };
            getCountries();
        } catch (error) {
            setCountries([]);
        } finally {
            // props.loading(false)
        }
    }, []);
    // function getAutoCompleteArrey(value: any) {
    //     let splitvalue = value.split(",");
    //     const temp = {
    //         city: splitvalue[0],
    //         state: splitvalue[1],
    //         country: splitvalue[2],
    //     };
    //     setAddressFormData({ ...addressFormData, ...temp });
    // }
    const dateFormat = "YYYY-MM-DD";
    const handleCloseCreativeImageModal = () => {
        setHandleCreative(false)
        const bodyClass = document.getElementsByTagName('html')[0];
        if (bodyClass) {
            bodyClass.classList.remove("bodyInnerModalActive");
        }
    }

    const handleCreativeZoom = () => {
        setHandleCreative(true)
        const bodyClass = document.getElementsByTagName('html')[0];
        if (bodyClass) {
            bodyClass.classList.add("bodyInnerModalActive");
        }
    }
    const [isVisible, setIsVisible] = useState(true);

    const handleClosePreviewImage = () => {
        setIsVisible(false);
    };

    async function getStatesForCountry(countryId: any) {
        try {
            const countryObj = countries.find((c) => c.id == countryId);
            if (!countryObj) {
                setStates([]);
                return;
            }
            let dialing_code = countryObj?.dialing_code || countryObj?.dial_code || '';
            dialing_code = dialing_code.replace(/^\+/, '');
            const res = await publicService.getState({ dialing_code, country_id: countryObj.id });
            if (res?.status === 1) setStates(res.data || []);
            else setStates([]);
        } catch (error) {
            setStates([]);
        }
    }

    async function getCitiesForState(stateId: any) {
        try {
            const res = await publicService.getCity({ state_id: stateId });
            if (res?.status === 1) setCities(res.data || []);
            else setCities([]);
        } catch (error) {
            setCities([]);
        }
    }

    const handleCountrySelect = async (_e: any, newValue: any) => {
        const countryId = newValue?.id ?? '';
        setAddressFormData({ ...addressFormData, country: newValue?.name || '', country_id: countryId, country_code: newValue?.country_code || '', state: '', state_id: '', city: '', city_id: '' });
        setStates([]);
        setCities([]);
        await getStatesForCountry(countryId);
    };

    const handleStateSelect = async (_e: any, newValue: any) => {
        const stateId = newValue?.id ?? '';
        setAddressFormData({ ...addressFormData, state: newValue?.name || '', state_id: stateId, city: '', city_id: '' });
        setCities([]);
        await getCitiesForState(stateId);
    };

    const handleCitySelect = (_e: any, newValue: any) => {
        setAddressFormData({ ...addressFormData, city: newValue?.name || '', city_id: newValue?.id ?? '' });
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const handleAddressPopupClose = () => {
        setAddAddressPopupOpen(false);
    };
    const handleOpenAddressPopup = (data: any) => {
        setAddAddressPopupOpen(true);

    };
    const cancelAddAddress = () => {
        setShowInput(false);
        setAddAddressPopupOpen(false);
    };
    return (
        <div>
            <div className={`updateBarterProduct-container`}>
                <div className="app-step-container">
                    {/* STEP 1 — ADDRESS */}
                    <Accordion className="app-accordion light">
                        <AccordionSummary expandIcon={<ExpandMore />}>
                            <strong>Address details</strong>
                        </AccordionSummary>

                        <AccordionDetails>
                            <div className="section-content">

                                {proposalAddressId === 0 && (
                                    <button className="app-btn-primary" onClick={() => {
                                        setShowInput(true);

                                        if (isMobile) {
                                            setAddAddressPopupOpen(true);
                                        }
                                    }}>
                                        Add address
                                    </button>
                                )}
                                {showInput && (
                                    <>
                                        {isMobile ? (
                                            <SwipeableDrawer
                                                anchor="bottom"
                                                open={addAddressPopupOpen}
                                                onClose={cancelAddAddress}
                                                onOpen={handleOpenAddressPopup}
                                                className="popup-drawer shipping-drawer mobile-app-drawer"
                                            >
                                                <div className="form-block">

                                                    <div className='d-flex flex-wrap mb-3'>
                                                        <div className='col popup-drawer-header'>
                                                            <span className='align-self-center'>Add Address</span>

                                                            <IconButton
                                                                edge='end'
                                                                color='inherit'
                                                                onClick={cancelAddAddress}
                                                                aria-label='close'
                                                            >
                                                                <MaterialSymbol iconName='close' fontweight='200' />
                                                            </IconButton>
                                                        </div>
                                                    </div>
                                                    {/* <div className="row mx-0 mx-md-3">
                                                            <TextField
                                                                className="w-100 inputFieldSp"
                                                                size="small"
                                                                onChange={(e) =>
                                                                    setAddressFormData({
                                                                        ...addressFormData,
                                                                        house_no: e.target.value,
                                                                    })
                                                                }
                                                                id="id_house_no"
                                                                label="Flat. House no."
                                                            />
                                                            <TextField
                                                                className="w-100 inputFieldSp"
                                                                size="small"
                                                                onChange={(e) =>
                                                                    setAddressFormData({
                                                                        ...addressFormData,
                                                                        area: e.target.value,
                                                                    })
                                                                }
                                                                id="id_area"
                                                                label="Area"
                                                            />
                                                            <TextField
                                                                className="w-100 inputFieldSp"
                                                                size="small"
                                                                onChange={(e) =>
                                                                    setAddressFormData({
                                                                        ...addressFormData,
                                                                        landmark: e.target.value,
                                                                    })
                                                                }
                                                                id="id_landmark"
                                                                label="Landmark"
                                                            />

                                                            <Autocomplete
                                                                className="inputFieldSp"
                                                                size="small"
                                                                disablePortal
                                                                id="combo-box-demo"
                                                                onChange={(e: any, v) => getAutoCompleteArrey(v)}
                                                                ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
                                                                options={
                                                                    location
                                                                        ? location?.map(
                                                                            (res: {
                                                                                id: number;
                                                                                city: string;
                                                                                state: string;
                                                                                country: string;
                                                                            }) => {
                                                                                return `${res.city}, ${res.state}, ${res.country}`;
                                                                            }
                                                                        )
                                                                        : ["No Data"]
                                                                }
                                                                renderInput={(params) => {
                                                                    return (
                                                                        <TextField
                                                                            name="location_id"
                                                                            {...params}
                                                                            label="Location"
                                                                        />
                                                                    );
                                                                }}
                                                            />

                                                            <TextField
                                                                className="w-100 inputFieldSp"
                                                                size="small"
                                                                onChange={(e) =>
                                                                    setAddressFormData({
                                                                        ...addressFormData,
                                                                        pincode: e.target.value,
                                                                    })
                                                                }
                                                                id="id_pincode"
                                                                label="Pincode"
                                                            />
                                                            <FormControl
                                                                fullWidth
                                                                size="small"
                                                                className="inputFieldSp"
                                                            >
                                                                <InputLabel id="demo-multiple-name-label ">
                                                                    Address type
                                                                </InputLabel>
                                                                <Select
                                                                    name="address_type"
                                                                    size="small"
                                                                    labelId="demo-multiple-name-label"
                                                                    id="demo-multiple-name"
                                                                    value={addressFormData.residency_type}
                                                                    onChange={(e) =>
                                                                        setAddressFormData({
                                                                            ...addressFormData,
                                                                            residency_type: e.target.value,
                                                                        })
                                                                    }
                                                                    label="Address type"
                                                                    MenuProps={MenuPropsSelect}
                                                                >
                                                                    <MenuItem value={"Home"}>
                                                                        Home (7am to 9pm delivery)
                                                                    </MenuItem>
                                                                    <MenuItem value={"Office"}>
                                                                        Office/Commercial (10am to 6pm delivery)
                                                                    </MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                            <FormControlLabel
                                                                defaultChecked={false}
                                                                onChange={(e, v) =>
                                                                    setAddressFormData({
                                                                        ...addressFormData,
                                                                        default_address: `${v}`,
                                                                    })
                                                                }
                                                                control={<Checkbox />}
                                                                label="Set as Default"
                                                            />
                                                            <div className="col save-add-can-buttons">
                                                                <LoadingButton
                                                                    id="id_login_btn"
                                                                    loading={loading}
                                                                    loadingPosition="start"
                                                                    className="btn btn-black"
                                                                    variant="contained"
                                                                    onClick={saveAddress}
                                                                >
                                                                    Save
                                                                </LoadingButton>
                                                                <Button
                                                                    className="btn"
                                                                    onClick={() => setShowInput(!showInput)}
                                                                    variant="outlined"
                                                                    color="error"
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            </div>
                                                        </div> */}
                                                    <div className="add-address px-4">
                                                        <Grid container rowSpacing={2} spacing={2}>
                                                            <Grid item xs={12} md={12}>
                                                                <TextField
                                                                    className='w-100 inputFieldSp'
                                                                    size='small'
                                                                    value={addressFormData.full_name}
                                                                    onChange={(e) =>
                                                                        setAddressFormData({
                                                                            ...addressFormData,
                                                                            full_name: e.target.value,
                                                                        })
                                                                    }
                                                                    error={!addressErrors?.full_name?.status}
                                                                    helperText={
                                                                        addressErrors?.full_name?.message
                                                                    }
                                                                    id='full_name'
                                                                    label='Full Name'
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={12}>
                                                                {/* <TextField
                                                                    className='w-100 inputFieldSp'
                                                                    size='small'
                                                                    value={addressFormData.mobile_no}
                                                                    onChange={(e) =>
                                                                        setAddressFormData({
                                                                            ...addressFormData,
                                                                            mobile_no: e.target.value,
                                                                        })
                                                                    }
                                                                    error={!addressFormData?.mobile_no?.status}
                                                                    helperText={
                                                                        addressErrors?.mobile_no?.message
                                                                    }
                                                                    id='mobile_no'
                                                                    label='Phone no.'
                                                                /> */}
                                                                <TextField
                                                                    className='w-100 inputFieldSp'
                                                                    label="Phone no."
                                                                    size="small"
                                                                    value={addressFormData.mobile_no}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value.replace(/\D/g, '').slice(0, 10);

                                                                        setAddressFormData({
                                                                            ...addressFormData,
                                                                            mobile_no: value,
                                                                        });

                                                                        if (typeof setAddressErrors === 'function') {
                                                                            setAddressErrors((prev: any) => ({
                                                                                ...prev,
                                                                                mobile_no: '',
                                                                            }));
                                                                        }
                                                                    }}
                                                                    error={!!addressErrors?.mobile_no}
                                                                    helperText={addressErrors?.mobile_no}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    className="w-100 inputFieldSp"
                                                                    size="small"
                                                                    label="Flat, House no., Building, Apartment"
                                                                    onChange={(e) =>
                                                                        setAddressFormData({
                                                                            ...addressFormData,
                                                                            house_no: e.target.value,
                                                                        })
                                                                    }
                                                                    error={!addressErrors?.house_no?.status}
                                                                    helperText={addressErrors?.house_no?.message}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    className="w-100 inputFieldSp"
                                                                    size="small"
                                                                    label="Area"
                                                                    onChange={(e) =>
                                                                        setAddressFormData({
                                                                            ...addressFormData,
                                                                            area: e.target.value,
                                                                        })
                                                                    }
                                                                    error={!addressErrors?.area?.status}
                                                                    helperText={addressErrors?.area?.message}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    className="w-100 inputFieldSp"
                                                                    size="small"
                                                                    label="Landmark"
                                                                    onChange={(e) =>
                                                                        setAddressFormData({
                                                                            ...addressFormData,
                                                                            landmark: e.target.value,
                                                                        })
                                                                    }
                                                                />
                                                            </Grid>

                                                            {/* <Grid item xs={12}>
            <Autocomplete
                className="inputFieldSp"
                size="small"
                disablePortal
                onChange={(e: any, v) => getAutoCompleteArrey(v)}
                ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
                options={
                    location
                        ? location.map(
                            (res: any) =>
                                `${res.city}, ${res.state}, ${res.country}`
                        )
                        : []
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Location"
                    />
                )}
            />
        </Grid> */}
                                                            <Grid item xs={12}>
                                                                <Autocomplete
                                                                    className='w-100 inputFieldSp'
                                                                    size='small'
                                                                    disablePortal
                                                                    id='country-select'
                                                                    options={countries || []}
                                                                    getOptionLabel={(option: any) => option?.name || ''}
                                                                    isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                                                                    value={countries.find((c: any) => c.id === addressFormData.country_id) || null}
                                                                    onChange={handleCountrySelect}
                                                                    ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            label='Country'
                                                                            error={!!addressErrors?.country_id}
                                                                            helperText={addressErrors?.country_id || ''}
                                                                        />
                                                                    )}
                                                                />

                                                                <Autocomplete
                                                                    className='w-100 inputFieldSp mt-2'
                                                                    size='small'
                                                                    disablePortal
                                                                    id='state-select'
                                                                    disabled={!addressFormData.country_id}
                                                                    options={states || []}
                                                                    getOptionLabel={(option: any) => option?.name || ''}
                                                                    isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                                                                    value={states.find((s: any) => s.id === addressFormData.state_id) || null}
                                                                    onChange={handleStateSelect}
                                                                    ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            label='State'
                                                                            error={!!addressErrors?.state_id}
                                                                            helperText={addressErrors?.state_id || ''}
                                                                        />
                                                                    )}
                                                                />

                                                                <Autocomplete
                                                                    className='w-100 inputFieldSp mt-2'
                                                                    size='small'
                                                                    disablePortal
                                                                    id='city-select'
                                                                    disabled={!addressFormData.state_id}
                                                                    options={cities || []}
                                                                    getOptionLabel={(option: any) => option?.name || ''}
                                                                    isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                                                                    value={cities.find((c: any) => c.id === addressFormData.city_id) || null}
                                                                    onChange={handleCitySelect}
                                                                    ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            label='City'
                                                                            error={!!addressErrors?.city_id}
                                                                            helperText={addressErrors?.city_id || ''}
                                                                        />
                                                                    )}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    className="w-100 inputFieldSp"
                                                                    size="small"
                                                                    label="Pincode"
                                                                    onChange={(e) =>
                                                                        setAddressFormData({
                                                                            ...addressFormData,
                                                                            pincode: e.target.value,
                                                                        })
                                                                    }
                                                                    error={!addressErrors?.pincode?.status}
                                                                    helperText={addressErrors?.pincode?.message}
                                                                />
                                                            </Grid>

                                                            {/* <Grid item xs={12}>
            <FormControl fullWidth size="small">
                <InputLabel>Address Type</InputLabel>
                <Select
                    value={addressFormData.residency_type}
                    label="Address Type"
                    onChange={(e) =>
                        setAddressFormData({
                            ...addressFormData,
                            residency_type: e.target.value,
                        })
                    }
                >
                    <MenuItem value="Home">Home</MenuItem>
                    <MenuItem value="Office">Office</MenuItem>
                </Select>
            </FormControl>
        </Grid> */}
                                                            <Grid item xs={12}>
                                                                <FormControl>
                                                                    <FormLabel>Select Address Type</FormLabel>

                                                                    <RadioGroup
                                                                        row
                                                                        value={addressFormData.residency_type}
                                                                        onChange={(e: any) =>
                                                                            setAddressFormData({
                                                                                ...addressFormData,
                                                                                residency_type: e.target.value,
                                                                            })
                                                                        }

                                                                    >
                                                                        <FormControlLabel
                                                                            value="Home"
                                                                            control={<Radio />}
                                                                            label="Home"

                                                                        />

                                                                        <FormControlLabel
                                                                            value="Office"
                                                                            control={<Radio />}
                                                                            label="Office"
                                                                        />
                                                                    </RadioGroup>
                                                                    {!addressErrors?.address_type?.status && (
                                                                        <span className="text-danger fs-12">
                                                                            {addressErrors?.address_type?.message}
                                                                        </span>
                                                                    )}
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <FormControlLabel
                                                                    control={<Checkbox />}
                                                                    label="Set as Default"
                                                                    onChange={(e, v) =>
                                                                        setAddressFormData({
                                                                            ...addressFormData,
                                                                            default_address: v,
                                                                        })
                                                                    }
                                                                />
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                xs={12}
                                                                className="mobile-app-drawer-footer"
                                                                display="flex"
                                                                justifyContent="flex-end"
                                                            >
                                                                <Button
                                                                    variant="outlined"
                                                                    onClick={cancelAddAddress}
                                                                >
                                                                    Cancel
                                                                </Button>

                                                                <LoadingButton
                                                                    loading={loading}
                                                                    className="ms-2"
                                                                    variant="contained"
                                                                    onClick={saveAddress}
                                                                >
                                                                    Save
                                                                </LoadingButton>
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                </div>
                                            </SwipeableDrawer>
                                        ) : (
                                            <div className="form-block">
                                                <div className="add-address">
                                                    <div className="row">
                                                        <div className="col">
                                                            <HeadingStyle title="Add Address" />
                                                        </div>
                                                    </div>
                                                    <div className="row mx-0 mx-md-3">
                                                        <TextField
                                                            className="w-100 inputFieldSp"
                                                            size="small"
                                                            onChange={(e) =>
                                                                setAddressFormData({
                                                                    ...addressFormData,
                                                                    house_no: e.target.value,
                                                                })
                                                            }
                                                            id="id_house_no"
                                                            label="Flat. House no."
                                                        />
                                                        <TextField
                                                            className="w-100 inputFieldSp"
                                                            size="small"
                                                            onChange={(e) =>
                                                                setAddressFormData({
                                                                    ...addressFormData,
                                                                    area: e.target.value,
                                                                })
                                                            }
                                                            id="id_area"
                                                            label="Area"
                                                        />
                                                        <TextField
                                                            className="w-100 inputFieldSp"
                                                            size="small"
                                                            onChange={(e) =>
                                                                setAddressFormData({
                                                                    ...addressFormData,
                                                                    landmark: e.target.value,
                                                                })
                                                            }
                                                            id="id_landmark"
                                                            label="Landmark"
                                                        />

                                                        {/* <Autocomplete
                                                            className="inputFieldSp"
                                                            size="small"
                                                            disablePortal
                                                            id="combo-box-demo"
                                                            onChange={(e: any, v) => getAutoCompleteArrey(v)}
                                                            ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
                                                            options={
                                                                location
                                                                    ? location?.map(
                                                                        (res: {
                                                                            id: number;
                                                                            city: string;
                                                                            state: string;
                                                                            country: string;
                                                                        }) => {
                                                                            return `${res.city}, ${res.state}, ${res.country}`;
                                                                        }
                                                                    )
                                                                    : ["No Data"]
                                                            }
                                                            renderInput={(params) => {
                                                                return (
                                                                    <TextField
                                                                        name="location_id"
                                                                        {...params}
                                                                        label="Location"
                                                                    />
                                                                );
                                                            }}
                                                        /> */}

                                                        <TextField
                                                            className="w-100 inputFieldSp"
                                                            size="small"
                                                            onChange={(e) =>
                                                                setAddressFormData({
                                                                    ...addressFormData,
                                                                    pincode: e.target.value,
                                                                })
                                                            }
                                                            id="id_pincode"
                                                            label="Pincode"
                                                        />
                                                        <FormControl
                                                            fullWidth
                                                            size="small"
                                                            className="inputFieldSp"
                                                        >
                                                            <InputLabel id="demo-multiple-name-label ">
                                                                Address type
                                                            </InputLabel>
                                                            <Select
                                                                name="address_type"
                                                                size="small"
                                                                labelId="demo-multiple-name-label"
                                                                id="demo-multiple-name"
                                                                value={addressFormData.residency_type}
                                                                onChange={(e) =>
                                                                    setAddressFormData({
                                                                        ...addressFormData,
                                                                        residency_type: e.target.value,
                                                                    })
                                                                }
                                                                label="Address type"
                                                                MenuProps={MenuPropsSelect}
                                                            >
                                                                <MenuItem value={"Home"}>
                                                                    Home (7am to 9pm delivery)
                                                                </MenuItem>
                                                                <MenuItem value={"Office"}>
                                                                    Office/Commercial (10am to 6pm delivery)
                                                                </MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                        <FormControlLabel
                                                            defaultChecked={false}
                                                            onChange={(e, v) =>
                                                                setAddressFormData({
                                                                    ...addressFormData,
                                                                    default_address: `${v}`,
                                                                })
                                                            }
                                                            control={<Checkbox />}
                                                            label="Set as Default"
                                                        />
                                                        <div className="col save-add-can-buttons">
                                                            <LoadingButton
                                                                id="id_login_btn"
                                                                loading={loading}
                                                                loadingPosition="start"
                                                                className="btn btn-black"
                                                                variant="contained"
                                                                onClick={saveAddress}
                                                            >
                                                                Save
                                                            </LoadingButton>
                                                            <Button
                                                                className="btn"
                                                                onClick={() => setShowInput(!showInput)}
                                                                variant="outlined"
                                                                color="error"
                                                            >
                                                                Cancel
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                                {/* {showInput && (
                            <div className="form-block">
                                <div className="add-address">
                                    <div className="row">
                                        <div className="col">
                                            <HeadingStyle title="Add Address" />
                                        </div>
                                    </div>
                                    <div className="row mx-0 mx-md-3">
                                        <TextField
                                            className="w-100 inputFieldSp"
                                            size="small"
                                            onChange={(e) =>
                                                setAddressFormData({
                                                    ...addressFormData,
                                                    house_no: e.target.value,
                                                })
                                            }
                                            id="id_house_no"
                                            label="Flat. House no."
                                        />
                                        <TextField
                                            className="w-100 inputFieldSp"
                                            size="small"
                                            onChange={(e) =>
                                                setAddressFormData({
                                                    ...addressFormData,
                                                    area: e.target.value,
                                                })
                                            }
                                            id="id_area"
                                            label="Area"
                                        />
                                        <TextField
                                            className="w-100 inputFieldSp"
                                            size="small"
                                            onChange={(e) =>
                                                setAddressFormData({
                                                    ...addressFormData,
                                                    landmark: e.target.value,
                                                })
                                            }
                                            id="id_landmark"
                                            label="Landmark"
                                        />

                                        <Autocomplete
                                            className="inputFieldSp"
                                            size="small"
                                            disablePortal
                                            id="combo-box-demo"
                                            onChange={(e: any, v) => getAutoCompleteArrey(v)}
                                            ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
                                            options={
                                                location
                                                    ? location?.map(
                                                        (res: {
                                                            id: number;
                                                            city: string;
                                                            state: string;
                                                            country: string;
                                                        }) => {
                                                            return `${res.city}, ${res.state}, ${res.country}`;
                                                        }
                                                    )
                                                    : ["No Data"]
                                            }
                                            renderInput={(params) => {
                                                return (
                                                    <TextField
                                                        name="location_id"
                                                        {...params}
                                                        label="Location"
                                                    />
                                                );
                                            }}
                                        />

                                        <TextField
                                            className="w-100 inputFieldSp"
                                            size="small"
                                            onChange={(e) =>
                                                setAddressFormData({
                                                    ...addressFormData,
                                                    pincode: e.target.value,
                                                })
                                            }
                                            id="id_pincode"
                                            label="Pincode"
                                        />
                                        <FormControl
                                            fullWidth
                                            size="small"
                                            className="inputFieldSp"
                                        >
                                            <InputLabel id="demo-multiple-name-label ">
                                                Address type
                                            </InputLabel>
                                            <Select
                                                name="address_type"
                                                size="small"
                                                labelId="demo-multiple-name-label"
                                                id="demo-multiple-name"
                                                value={addressFormData.residency_type}
                                                onChange={(e) =>
                                                    setAddressFormData({
                                                        ...addressFormData,
                                                        residency_type: e.target.value,
                                                    })
                                                }
                                                label="Address type"
                                                MenuProps={MenuPropsSelect}
                                            >
                                                <MenuItem value={"Home"}>
                                                    Home (7am to 9pm delivery)
                                                </MenuItem>
                                                <MenuItem value={"Office"}>
                                                    Office/Commercial (10am to 6pm delivery)
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                        <FormControlLabel
                                            defaultChecked={false}
                                            onChange={(e, v) =>
                                                setAddressFormData({
                                                    ...addressFormData,
                                                    default_address: `${v}`,
                                                })
                                            }
                                            control={<Checkbox />}
                                            label="Set as Default"
                                        />
                                        <div className="col save-add-can-buttons">
                                            <LoadingButton
                                                id="id_login_btn"
                                                loading={loading}
                                                loadingPosition="start"
                                                className="btn btn-black"
                                                variant="contained"
                                                onClick={saveAddress}
                                            >
                                                Save
                                            </LoadingButton>
                                            <Button
                                                className="btn"
                                                onClick={() => setShowInput(!showInput)}
                                                variant="outlined"
                                                color="error"
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )} */}

                                {!showInput && proposalAddressId === 0 ? (
                                    <ShippingAddressCard
                                        addressList={addressList}
                                        setDefaultAddress={sendAddress}
                                        enableSetDefault={true}
                                        enableEdit={false}
                                        onChange={updateDefaultAddress}
                                    />
                                ) : (
                                    <div>
                                        {addressList?.map((data: any) =>
                                            data.address_id === proposalAddressId && (
                                                <div key={data.address_id}>
                                                    {data.house_no && <div>{data.house_no}</div>}
                                                    {data.landmark && <div>{data.landmark}</div>}
                                                    {data.city && <div>{data.city} - {data.pincode}</div>}
                                                    {data.state && <div>{data.state}</div>}
                                                    {data.country && <div>{data.country}</div>}
                                                </div>
                                            )
                                        )}
                                    </div>
                                )}

                            </div>
                        </AccordionDetails>
                    </Accordion>

                    {/* STEP 2 — SHIPPING */}
                    <Accordion className="app-accordion light" disabled={proposalAddressId === 0}>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                            <strong>Product Shipping Details</strong>
                        </AccordionSummary>

                        <AccordionDetails>
                            <div className="section-content product-shipping-detail">
                                <p>The brand shares the product shipping details for your
                                    reference.</p>
                                {proposalData?.[0]?.shipping_details && (
                                    <>
                                        <div className='d-none d-md-flex flex-column'>
                                            <strong>Tracking Details</strong>
                                            <p>{proposalData[0].shipping_details}</p>
                                        </div>
                                        <div className='position-relative d-flex flex-column'>
                                            <img
                                                className="preview-img"
                                                src={proposalData[0].shipping_receipt_url}
                                            />
                                            <button className="app-btn-outline" onClick={handleCreativeZoom}>
                                                <MaterialSymbol iconName='download' fontweight='200' fontSize='30px' />
                                            </button>
                                        </div>
                                        <div className='d-flex d-md-none mt-3'>
                                            <strong>Tracking Details: &nbsp;</strong>
                                            <p>{proposalData[0].shipping_details}</p>
                                        </div>
                                    </>
                                )}

                            </div>
                        </AccordionDetails>
                    </Accordion>

                    {/* STEP 3 — DELIVERY */}
                    <Accordion
                        className="app-accordion light app-accordion-acknowledge"
                        disabled={proposalData?.[0]?.shipping_receipt_url?.length === 0}
                    >
                        <AccordionSummary expandIcon={<ExpandMore />}>
                            <strong>Product Delivery Acknowledgement</strong>
                        </AccordionSummary>

                        <AccordionDetails>
                            <div className="delivery-acknowledgement-form">
                                <div className="section-content">

                                    {proposalData?.[0]?.product_delivery_status === "Pending" ? (
                                        <>
                                            <label className="delivery-checkbox">
                                                <Checkbox
                                                    checked={termsAccept}
                                                    onChange={(e, checked) => setTermsAccept(checked)}
                                                    sx={{
                                                        color: '#fff',
                                                        '&.Mui-checked': {
                                                            color: '#1976d2',
                                                        },
                                                    }}
                                                />

                                                <span>Yes, I have received the product.</span>
                                            </label>
                                            <div
                                                className="upload-box"
                                                onClick={() => setShowUploadPopup(true)}
                                            >
                                                {productDeliveryImage ? (
                                                    <img
                                                        src={productDeliveryImage}
                                                        className="upload-preview"
                                                        alt="Product"
                                                    />
                                                ) : (
                                                    <div className="upload-placeholder">
                                                        <MaterialSymbol
                                                            iconName="upload"
                                                            fontweight="200"
                                                            fontSize="28px"
                                                        />
                                                        <span>Upload Image</span>
                                                    </div>
                                                )}
                                            </div>
                                            {deliveryErrors?.productImage && (
                                                <div className="text-danger mt-1">
                                                    {deliveryErrors?.productImage}
                                                </div>
                                            )}

                                            <FormControl fullWidth size="small">
                                                <Select
                                                    displayEmpty
                                                    defaultValue=""
                                                    IconComponent={ExpandMore}
                                                    onChange={(e) =>
                                                        setProductCondition?.(
                                                            e.target.value as ProductCondition
                                                        )
                                                    }
                                                >
                                                    <MenuItem disabled value="">
                                                        Product Condition
                                                    </MenuItem>

                                                    <MenuItem value="Good">Good</MenuItem>
                                                    <MenuItem value="Broken">Broken</MenuItem>
                                                    <MenuItem value="Expired">Expired</MenuItem>
                                                </Select>
                                            </FormControl>

                                            <TextField
                                                multiline
                                                rows={2}
                                                placeholder="Add Comments (optional)"
                                                fullWidth
                                                onChange={(e) =>
                                                    setProductDeliveryRemark(e.target.value)
                                                }
                                            />

                                            {/* <div className="creative-date-info">
        The creative will be shared by{" "}
        <span>
            {proposalData?.[0]?.creative_due_date
                ? dayjs(
                    proposalData[0].creative_due_date
                ).format("DD MMM YYYY")
                : "Add Date"}
        </span>
    </div> */}
                                            <div className="creative-date-info">
                                                The creative will be shared by{" "}
                                                <span
                                                    className="date-link"
                                                    onClick={() => setOpenDatePicker(true)}
                                                >
                                                    {selectedDate
                                                        ? dayjs(selectedDate).format("DD MMM YYYY")
                                                        : "Add Date"}
                                                </span>
                                            </div>

                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <MobileDatePicker
                                                    open={openDatePicker}
                                                    value={selectedDate}
                                                    minDate={dayjs()}
                                                    onClose={() => setOpenDatePicker(false)}
                                                    onChange={(value) => {
                                                        setSelectedDate(value);

                                                        if (value) {
                                                            setRecivedProductDate?.(
                                                                dayjs(value).format("YYYY-MM-DD")
                                                            );
                                                        }
                                                    }}
                                                    slotProps={{
                                                        textField: {
                                                            sx: { display: "none" },
                                                        },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                            <div className='delivery-send-btn-wrapper'>
                                                <LoadingButton
                                                    className="delivery-send-btn"
                                                    loading={loading}
                                                    onClick={sendReciviedProduct}
                                                >
                                                    Send
                                                </LoadingButton>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="delivery-summary">

                                                <img
                                                    className="delivery-summary-image"
                                                    src={proposalData[0].product_delivery_image_url}
                                                    alt="Product Delivery"
                                                />

                                                <div className="delivery-summary-field">
                                                    <span>{proposalData?.[0]?.product_condition}</span>
                                                    <MaterialSymbol
                                                        iconName="keyboard_arrow_down"
                                                        fontweight="200"
                                                    />
                                                </div>

                                                {proposalData?.[0]?.product_delivery_remarks && (
                                                    <div className="delivery-summary-comment">
                                                        {proposalData[0].product_delivery_remarks}
                                                    </div>
                                                )}

                                                {proposalData?.[0]?.product_delivery_date && (
                                                    <div className="delivery-summary-date">
                                                        The creative will be shared by{" "}
                                                        {dayjs(proposalData[0].product_delivery_date).format(
                                                            "DD MMM YYYY"
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            {/* <p><strong>Product Condition:</strong> {proposalData?.[0]?.product_condition}</p>

                                            {proposalData?.[0]?.product_delivery_remarks && (
                                                <p><strong>Comments:</strong> {proposalData[0].product_delivery_remarks}</p>
                                            )}

                                            <img
                                                className="preview-img"
                                                src={proposalData[0].product_delivery_image_url}
                                            /> */}
                                        </>
                                    )}

                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </div>
                <div className='d-none d-md-flex flex-md-column'>
                    <div className="product-detail-container">

                        <div className="product-detail-title-sec flex-row">
                            <div className="col">
                                <h5>
                                    <strong>Step 1 (Influencer) :</strong> Address Details{" "}
                                </h5>
                                <h6>The product delivery address.</h6>
                            </div>
                            <div className="col text-end">
                                {proposalAddressId === 0 && (
                                    <button type="button"
                                        className="btn btn-primary"
                                        onClick={() => setShowInput(!showInput)}
                                    >
                                        Add address
                                    </button>
                                )}
                            </div>
                        </div>

                        <div>
                            {showInput && (
                                <div className="add-address">
                                    <div className="row">
                                        <div className="col">
                                            <HeadingStyle title="Add Address" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="row">
                                            <TextField
                                                className="w-100 inputFieldSp"
                                                size="small"
                                                value={addressFormData.full_name}
                                                error={!!addressErrors?.full_name}
                                                helperText={addressErrors?.full_name || ""}
                                                onChange={(e) =>
                                                    setAddressFormData({
                                                        ...addressFormData,
                                                        full_name: e.target.value,
                                                    })
                                                }
                                                id="id_full_name"
                                                label="Full Name"
                                            />
                                            <TextField
                                                className="w-100 inputFieldSp"
                                                size="small"
                                                value={addressFormData.mobile_no}
                                                error={!!addressErrors?.mobile_no}
                                                helperText={addressErrors?.mobile_no || ""}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, '').slice(0, 10);

                                                    setAddressFormData({
                                                        ...addressFormData,
                                                        mobile_no: value,
                                                    });

                                                    if (typeof setAddressErrors === 'function') {
                                                        setAddressErrors((prev: any) => ({
                                                            ...prev,
                                                            mobile_no: '',
                                                        }));
                                                    }
                                                }}
                                                id="id_mobile_no"
                                                label="Phone no."
                                            />
                                            <TextField
                                                className="w-100 inputFieldSp"
                                                size="small"
                                                error={!!addressErrors?.house_no}
                                                helperText={addressErrors?.house_no || ""}
                                                onChange={(e) =>
                                                    setAddressFormData({
                                                        ...addressFormData,
                                                        house_no: e.target.value,
                                                    })
                                                }
                                                id="id_house_no"
                                                label="Flat. House no."
                                            />
                                            <TextField
                                                className="w-100 inputFieldSp"
                                                size="small"
                                                error={!!addressErrors?.area}
                                                helperText={addressErrors?.area || ""}
                                                onChange={(e) =>
                                                    setAddressFormData({
                                                        ...addressFormData,
                                                        area: e.target.value,
                                                    })
                                                }
                                                id="id_area"
                                                label="Area"
                                            />
                                            <TextField
                                                className="w-100 inputFieldSp"
                                                size="small"
                                                onChange={(e) =>
                                                    setAddressFormData({
                                                        ...addressFormData,
                                                        landmark: e.target.value,
                                                    })
                                                }
                                                id="id_landmark"
                                                label="Landmark"
                                            />

                                            {/* <Autocomplete
                                                className="inputFieldSp"
                                                size="small"
                                                disablePortal
                                                id="combo-box-demo"
                                                onChange={(e: any, v) => getAutoCompleteArrey(v)}
                                                ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
                                                options={
                                                    location
                                                        ? location?.map(
                                                            (res: {
                                                                id: number;
                                                                city: string;
                                                                state: string;
                                                                country: string;
                                                            }) => {
                                                                return `${res.city}, ${res.state}, ${res.country}`;
                                                            }
                                                        )
                                                        : ["No Data"]
                                                }
                                                renderInput={(params) => {
                                                    return (
                                                        <TextField
                                                            name="location_id"
                                                            {...params}
                                                            label="Location"
                                                        />
                                                    );
                                                }}
                                            /> */}

                                            <Autocomplete
                                                className='w-100 inputFieldSp'
                                                size='small'
                                                disablePortal
                                                id='country-select'
                                                options={countries || []}
                                                getOptionLabel={(option: any) => option?.name || ''}
                                                isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                                                value={countries.find((c: any) => c.id === addressFormData.country_id) || null}
                                                onChange={handleCountrySelect}
                                                ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label='Country'
                                                        error={!!addressErrors?.country_id}
                                                        helperText={addressErrors?.country_id || ''}
                                                    />
                                                )}
                                            />

                                            <Autocomplete
                                                className='w-100 inputFieldSp mt-2'
                                                size='small'
                                                disablePortal
                                                id='state-select'
                                                disabled={!addressFormData.country_id}
                                                options={states || []}
                                                getOptionLabel={(option: any) => option?.name || ''}
                                                isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                                                value={states.find((s: any) => s.id === addressFormData.state_id) || null}
                                                onChange={handleStateSelect}
                                                ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label='State'
                                                        error={!!addressErrors?.state_id}
                                                        helperText={addressErrors?.state_id || ''}
                                                    />
                                                )}
                                            />

                                            <Autocomplete
                                                className='w-100 inputFieldSp mt-2'
                                                size='small'
                                                disablePortal
                                                id='city-select'
                                                disabled={!addressFormData.state_id}
                                                options={cities || []}
                                                getOptionLabel={(option: any) => option?.name || ''}
                                                isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                                                value={cities.find((c: any) => c.id === addressFormData.city_id) || null}
                                                onChange={handleCitySelect}
                                                ListboxProps={MenuPropsAutoCompleteNoCheckBox.PaperProps}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label='City'
                                                        error={!!addressErrors?.city_id}
                                                        helperText={addressErrors?.city_id || ''}
                                                    />
                                                )}
                                            />

                                            <TextField
                                                className="w-100 inputFieldSp"
                                                size="small"
                                                error={!!addressErrors?.pincode}
                                                helperText={addressErrors?.pincode || ""}
                                                onChange={(e) =>
                                                    setAddressFormData({
                                                        ...addressFormData,
                                                        pincode: e.target.value,
                                                    })
                                                }
                                                id="id_pincode"
                                                label="Pincode"
                                            />
                                            <FormControl
                                                fullWidth
                                                size="small"
                                                className="inputFieldSp"
                                                error={!!addressErrors?.residency_type}
                                            >
                                                <InputLabel id="demo-multiple-name-label ">
                                                    Address type
                                                </InputLabel>
                                                <Select
                                                    name="address_type"
                                                    size="small"
                                                    labelId="demo-multiple-name-label"
                                                    id="demo-multiple-name"
                                                    value={addressFormData.residency_type}
                                                    onChange={(e) =>
                                                        setAddressFormData({
                                                            ...addressFormData,
                                                            residency_type: e.target.value,
                                                        })
                                                    }
                                                    label="Address type"
                                                    MenuProps={MenuPropsSelect}
                                                >
                                                    <MenuItem value={"Home"}>
                                                        Home (7am to 9pm delivery)
                                                    </MenuItem>
                                                    <MenuItem value={"Office"}>
                                                        Office/Commercial (10am to 6pm delivery)
                                                    </MenuItem>
                                                </Select>
                                                {addressErrors?.residency_type && (
                                                    <div style={{ color: "#d32f2f", fontSize: "0.75rem" }}>
                                                        {addressErrors.residency_type}
                                                    </div>
                                                )}
                                            </FormControl>
                                            <FormControlLabel
                                                defaultChecked={false}
                                                onChange={(e, v) =>
                                                    setAddressFormData({
                                                        ...addressFormData,
                                                        default_address: `${v}`,
                                                    })
                                                }
                                                control={<Checkbox />}
                                                label="Set as Default"
                                            />
                                            <div className="col save-add-can-buttons">
                                                <LoadingButton
                                                    id="id_login_btn"
                                                    loading={loading}
                                                    loadingPosition="start"
                                                    className="btn btn-black"
                                                    variant="contained"
                                                    onClick={saveAddress}
                                                >
                                                    Save
                                                </LoadingButton>
                                                <Button
                                                    className="btn"
                                                    onClick={() => setShowInput(!showInput)}
                                                    variant="outlined"
                                                    color="error"
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {!showInput && proposalAddressId === 0 ? (
                                <div className="add-address">
                                    <ShippingAddressCard
                                        addressList={addressList}
                                        setDefaultAddress={sendAddress}
                                        enableEdit={false}
                                        enableSetDefault={true}
                                        onChange={updateDefaultAddress}
                                    />
                                </div>
                            ) : (
                                <div className='address-list'>
                                    {addressList &&
                                        addressList.map((data: any, index: number) => {
                                            if (data.address_id === proposalAddressId) {
                                                return (
                                                    <React.Fragment key={index}>
                                                        {data.house_no && <span className='fs-14 d-block'>{data.house_no}</span>}
                                                        {data.landmark && <span className='fs-14 d-block'>{data.landmark}</span>}
                                                        {data.city &&
                                                            <span className="fs-14 d-block">
                                                                {data.city} {data.pincode && ` - ${data.pincode}`}
                                                            </span>
                                                        }
                                                        {data.state && <span className='fs-14 d-block'>{data.state}</span>}
                                                        {data.country && <span className='fs-14 d-block'>{data.country}</span>}

                                                    </React.Fragment>
                                                );
                                            }
                                            return null;
                                        })}
                                </div>
                            )}
                        </div>
                    </div>

                    {
                        <div
                            className={`product-detail-container ${proposalAddressId > 0
                                ? " activefield"
                                : " deactivefield"
                                }`}
                        >
                            <div className="product-detail-title-sec">
                                <h5>
                                    <strong>Step 2 (Brand) : </strong> Product Shipping
                                    Details{" "}
                                </h5>
                                <h6>
                                    The brand shares the product shipping details for your
                                    reference.
                                </h6>
                            </div>

                            <div>
                                <div className="shipping_receipt_section">
                                    {proposalData && (
                                        <>
                                            {proposalData[0].shipping_details &&
                                                <strong className='d-block fs-14'>Tracking Details:</strong>
                                            }
                                            <span className='d-block mb-1 fs-14'> {proposalData[0].shipping_details}</span>

                                            {proposalData[0]?.shipping_details &&
                                                <><img
                                                    className="shipping_receipt_url mb-3"
                                                    src={proposalData[0].shipping_receipt_url}
                                                    alt="document"

                                                />
                                                    <button className='btn btn-outline-primary align-items-start mb-2'
                                                        style={{ cursor: 'pointer' }}
                                                        // download={proposalData[0].file_name}
                                                        onClick={handleCreativeZoom}
                                                    >
                                                        Download
                                                    </button>
                                                </>
                                            }
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    }
                    {
                        <div
                            className={`product-detail-container ${proposalData[0].shipping_receipt_url.length === 0
                                ? " deactivefield"
                                : " activefield"
                                }`}
                        >
                            <div className="product-detail-title-sec">
                                <h5>
                                    <strong>Step 3 (Influencer) :</strong> Product Delivery
                                    Acknowledgement{" "}
                                </h5>
                                <h6>
                                    Acknowledgement by the influencer and creative timeline
                                    for your reference.
                                </h6>
                            </div>
                            <div className="w-100">
                                {proposalData &&
                                    proposalData[0].product_delivery_status === "Pending" ? (
                                    <div className="shipping_receipt_section">
                                        <span>
                                            <Checkbox
                                                className="p-0"
                                                onChange={(e, v) => setTermsAccept(v)}
                                                defaultChecked={false}
                                            />{" "}
                                            Yes, I have received the product.
                                        </span>
                                        <span className="mt-3">
                                            <FormControl style={{ minWidth: '250px' }} size="small" >
                                                <InputLabel id="demo-simple-select-label">
                                                    Product Condition:
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    // value={age}
                                                    defaultValue={""}
                                                    label="Product Delivery Status"
                                                    onChange={(e) => {
                                                        const newValue = e.target.value as ProductCondition;

                                                        if (Object.values(ProductCondition).includes(newValue) && setProductCondition) {
                                                            setProductCondition(newValue);
                                                        } else if (setProductCondition) {
                                                            setProductCondition(ProductCondition.Good);
                                                        }
                                                    }
                                                    }
                                                    MenuProps={MenuPropsSelect}
                                                >
                                                    <MenuItem value={`Good`}>Good</MenuItem>
                                                    <MenuItem value={`Broken`}>Broken</MenuItem>
                                                    {/* <MenuItem value={`Rejected`}>Rejected</MenuItem> */}
                                                    <MenuItem value={`Expired`}>Expired</MenuItem>
                                                    {/* <MenuItem value={`Other`}>Other</MenuItem> */}
                                                </Select>
                                            </FormControl>
                                            <span className='d-flex align-items-center '><span className='fs-14'>Creative will be shared by </span><LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer
                                                    components={["shipping_receipt_section"]}
                                                >
                                                    <DatePicker
                                                        className="ms-2"
                                                        label=""
                                                        format="DD-MM-YYYY"
                                                        // minDate={"12-12-2020"}
                                                        minDate={dayjs(new Date())}
                                                        // defaultValue={"12-12-2020"}
                                                        onChange={(e: any) =>
                                                            setRecivedProductDate(e?.format(dateFormat))
                                                        }
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                // helperText: "MM/DD/YYYY",
                                                            },
                                                        }}
                                                    />
                                                </DemoContainer>
                                            </LocalizationProvider> </span>

                                            <TextField
                                                id="outlined-basic"
                                                label=""
                                                size="small"
                                                variant="outlined"
                                                rows={4}
                                                onChange={(e) =>
                                                    setProductDeliveryRemark(e.target.value)
                                                }
                                                className="mt-2 w-100"
                                                placeholder="Comments"
                                            />
                                            <span className="product-image-section">
                                                {(isVisible && productDeliveryImage) &&
                                                    <span className='d-inline-flex position-relative mt-3'>
                                                        <img
                                                            className="image-style "
                                                            src={productDeliveryImage}
                                                            alt="product"
                                                        />
                                                        <button
                                                            onClick={handleClosePreviewImage}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '-8px',
                                                                right: '-5px',
                                                                background: '#000',
                                                                color: 'white',
                                                                border: 'none',
                                                                borderRadius: '50%',
                                                                width: '24px',
                                                                height: '24px',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            <MaterialSymbol fontSize='14px' className='d-flex align-items-center' iconName='close' fontweight='200' />
                                                        </button>
                                                    </span>
                                                }
                                                {(!isVisible || !productDeliveryImage) && (
                                                    <LoadingButton
                                                        loading={loading}
                                                        loadingPosition="start"
                                                        className="btn btn-outline-primary mt-3"
                                                        variant="contained"
                                                        onClick={() =>
                                                            setShowUploadPopup(showUploadPopup)
                                                        }
                                                    >
                                                        Upload Product Image
                                                    </LoadingButton>
                                                )}
                                            </span>
                                            {showUploadPopup && (
                                                <FileUploadPopup
                                                    openModal={showUploadPopup}
                                                    onClose={() => setShowUploadPopup(showUploadPopup)}
                                                    onSend={(e: { url: string; key: string }) => {
                                                        productDeliveryImageUrl && productDeliveryImageUrl(e.url);
                                                        productDeliveryImagePath && productDeliveryImagePath(e.key);
                                                        setIsVisible(true)
                                                    }}
                                                    path={path}
                                                    acceptedFileTypes=".jpg, .jpeg, .png"
                                                />
                                            )}
                                        </span>
                                        <span className="mt-3 mb-3">
                                            <LoadingButton
                                                style={{
                                                    marginRight: `15px`,
                                                }}
                                                className="btn btn-primary"
                                                loading={loading}
                                                loadingPosition="start"
                                                variant="contained"
                                                onClick={sendReciviedProduct}
                                            >
                                                Send
                                            </LoadingButton>
                                        </span>
                                    </div>
                                ) : (
                                    <div className="shipping_receipt_section">
                                        <ul className='ps-0'>
                                            <li>
                                                {" "}
                                                <strong>Product Condition:</strong>{" "}
                                                {
                                                    proposalData?.[0]?.product_condition ?? "No Status"
                                                }
                                            </li>
                                            {/* <li>
                                                {" "}
                                                <strong>Delivery Date: </strong>
                                                {dayjs(
                                                    proposalData[0].product_delivery_date
                                                ).format("LL")}
                                            </li> */}
                                            {proposalData[0].product_delivery_remarks &&
                                                <li>
                                                    <strong>Comments: </strong>
                                                    {proposalData[0].product_delivery_remarks}
                                                </li>
                                            }
                                            <li>
                                                <span>
                                                    <strong>Product Image</strong>
                                                </span>
                                                <img
                                                    className="image-style"
                                                    src={proposalData[0].product_delivery_image_url}
                                                    alt="product delivery"
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                </div>
            </div>



            {createPortal(<CommonPopUp
                key={proposalData[0].proposal_id}
                className="creative-img-popup barter-shipping-detail"
                modalContent=""
                openModal={handleCreative}
                modalId={`creative-img-${proposalData[0].proposal_id}`}
                onClose={() => handleCloseCreativeImageModal()}
            >
                <div className="container-fluid">
                    <div className='row creative-detail inner'>
                        <div className='col-md-12'>

                            <div className="creative-detail-img">
                                <img
                                    src={proposalData[0].shipping_receipt_url}
                                    className="selected-creative"
                                    alt="shipping receipt"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </CommonPopUp>
                , document.body)}



        </div>
    )
}

export default BarterProductInfo